(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orm-department-filters"] && !Shopify.designMode) return;
  try {
    class OrmDepartmentFilters extends HTMLElement {
    connectedCallback() {
      this.syncFilters();
      this.addEventListener('click', this.resetFilters);
      document.addEventListener('shopify:collection:update', this.handleCollectionUpdate);
      this.observer = new MutationObserver(this.syncFilters);
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.resetFilters);
      document.removeEventListener('shopify:collection:update', this.handleCollectionUpdate);
      this.observer?.disconnect();
    }

    handleCollectionUpdate = (event) => {
      if (event.promise instanceof Promise) {
        event.promise.finally(this.syncFilters);
      } else {
        this.syncFilters();
      }
    };

    syncFilters = () => {
      requestAnimationFrame(() => {
        const params = new URLSearchParams(window.location.search);
        for (const name of ['filter.p.product_type', 'filter.p.vendor']) {
          const activeValues = params.getAll(name);
          this.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
            input.checked = activeValues.includes(input.value);
          });
        }
      });
    };

    resetFilters = (event) => {
      const control = event.target.closest('[data-reset-categories], [data-reset-vendors]');
      if (!control) return;

      const name = control.hasAttribute('data-reset-categories') ? 'filter.p.product_type' : 'filter.p.vendor';
      const checked = [...this.querySelectorAll(`input[name="${name}"]:checked`)];
      if (!checked.length) return;
      checked.forEach((input) => {
        input.checked = false;
      });
      checked[0].dispatchEvent(new Event('change', { bubbles: true }));
    };
  }

  if (!customElements.get('orm-department-filters')) {
    customElements.define('orm-department-filters', OrmDepartmentFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orm-hero-search-filters"] && !Shopify.designMode) return;
  try {
    class OrmFilterDropdown extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.type = this.dataset.dropdownType;
      this.input = this.querySelector('[data-filter-input]');
      this.items = Array.from(this.querySelectorAll('[data-filter-item]'));
      this.empty = this.querySelector('[data-filter-empty]');
      this.details = this.querySelector('details');
      this.selectedLabel = this.querySelector('[data-selected-label]');
      this.controlRow = this.closest('.orm-hero-search__control-row');
      this.hasDepartmentMappings = this.items.some((item) => item.dataset.departmentHandle);
      this.departmentHandle = '';

      this.input?.addEventListener('input', this.filter, { signal: this.controller.signal });
      this.details?.addEventListener('toggle', this.handleToggle, { signal: this.controller.signal });

      if (this.type === 'department') {
        this.items.forEach((item) => {
          item.addEventListener('click', this.selectDepartment, { signal: this.controller.signal });
        });
      } else if (this.type === 'category') {
        this.controlRow?.addEventListener('orm:department-change', this.handleDepartmentChange, {
          signal: this.controller.signal,
        });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    filter = () => {
      const query = this.input?.value.trim().toLocaleLowerCase() || '';
      let visibleCount = 0;

      this.items.forEach((item) => {
        const matchesQuery = item.textContent.trim().toLocaleLowerCase().includes(query);
        const matchesDepartment =
          this.type !== 'category' ||
          !this.hasDepartmentMappings ||
          !this.departmentHandle ||
          item.dataset.departmentHandle === this.departmentHandle;
        const visible = matchesQuery && matchesDepartment;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.empty) this.empty.hidden = visibleCount > 0;
    };

    selectDepartment = (event) => {
      const selected = event.currentTarget;

      this.items.forEach((item) => {
        item.setAttribute('aria-pressed', String(item === selected));
      });

      const departmentTitle = selected.textContent.trim();

      if (this.selectedLabel) this.selectedLabel.textContent = departmentTitle;
      if (this.details) this.details.open = false;
      this.updateSearchFilter(departmentTitle);

      this.controlRow?.dispatchEvent(
        new CustomEvent('orm:department-change', {
          detail: { handle: selected.dataset.departmentHandle || '' },
        })
      );
    };

    updateSearchFilter(departmentTitle) {
      const predictiveSearch = this.controlRow?.querySelector('predictive-search-component');
      if (!predictiveSearch) return;

      if (typeof predictiveSearch.setDepartmentFilter === 'function') {
        predictiveSearch.setDepartmentFilter(departmentTitle);
        return;
      }

      customElements.whenDefined('predictive-search-component').then(() => {
        predictiveSearch.setDepartmentFilter?.(departmentTitle);
      });
    }

    handleDepartmentChange = (event) => {
      this.departmentHandle = event.detail.handle;
      if (this.input) this.input.value = '';
      this.filter();
      if (this.details) this.details.open = true;
    };

    handleToggle = () => {
      if (this.details?.open) {
        this.controlRow?.querySelectorAll('orm-filter-dropdown details[open]').forEach((details) => {
          if (details !== this.details) details.open = false;
        });
        return;
      }

      if (!this.input) return;
      this.input.value = '';
      this.filter();
    };
  }

  if (!customElements.get('orm-filter-dropdown')) {
    customElements.define('orm-filter-dropdown', OrmFilterDropdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    class PriceRangeSlider extends HTMLElement {
    connectedCallback() {
      this.minimum = this.querySelector('[data-range-min]');
      this.maximum = this.querySelector('[data-range-max]');
      this.priceFacet = this.closest('price-facet-component');
      this.minInput = this.priceFacet?.querySelector('[ref="minInput"]');
      this.maxInput = this.priceFacet?.querySelector('[ref="maxInput"]');
      if (!this.minimum || !this.maximum || !this.minInput || !this.maxInput) return;

      this.minimum.addEventListener('input', this.update);
      this.maximum.addEventListener('input', this.update);
      this.minimum.addEventListener('change', this.commit);
      this.maximum.addEventListener('change', this.commit);
      this.update();
    }

    disconnectedCallback() {
      this.minimum?.removeEventListener('input', this.update);
      this.maximum?.removeEventListener('input', this.update);
      this.minimum?.removeEventListener('change', this.commit);
      this.maximum?.removeEventListener('change', this.commit);
    }

    update = (event) => {
      if (Number(this.minimum.value) > Number(this.maximum.value)) {
        if (event?.target === this.minimum) {
          this.minimum.value = this.maximum.value;
        } else {
          this.maximum.value = this.minimum.value;
        }
      }

      const range = Number(this.maximum.max) || 1;
      this.style.setProperty('--range-start', `${(Number(this.minimum.value) / range) * 100}%`);
      this.style.setProperty('--range-end', `${(Number(this.maximum.value) / range) * 100}%`);
      this.minInput.value = this.minimum.value;
      this.maxInput.value = this.maximum.value;
    };

    commit = (event) => {
      this.update(event);
      const input = event.target === this.minimum ? this.minInput : this.maxInput;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
  }

  if (!customElements.get('price-range-slider')) {
    customElements.define('price-range-slider', PriceRangeSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
